import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import Breadcrumb from "../elements/common/Breadcrumb"; // Asumiendo que este componente puede manejar títulos dinámicos
import CounterOne from "../elements/counters/CounterOne"; // Este componente podría necesitar traducción interna
import Testimonial from "../elements/Testimonial"; // Este componente podría necesitar traducción interna
import BrandTwo from "../elements/BrandTwo"; // Este componente podría necesitar traducción interna
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa"; // Iconos se mantienen
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi"; // Icono se mantiene
import Header from "../component/header/Header"; // Asumiendo traducido o configuración externa
import Footer from "../component/footer/Footer"; // Asumiendo traducido o configuración externa

// Importaciones de imágenes se mantienen
import about from "../assets/images/about/about-3.jpg";
import findingImg from "../assets/images/about/finding-us-01.png";
import teamImg1 from "../assets/images/team/team-01.jpg";
import teamImg2 from "../assets/images/team/team-02.jpg";
import teamImg3 from "../assets/images/team/team-03.jpg";

class About extends Component {
  render() {
    // Título principal de la sección
    let title = "Nosotros";
    // Descripción general de la agencia (Placeholder - REEMPLAZAR CON CONTENIDO REAL)
    let description =
      "Somos Space Marketing, tu socio estratégico en marketing digital. Impulsamos tu crecimiento con soluciones innovadoras en SEO, gestión de redes sociales, desarrollo de software a medida y creación de marcas personales impactantes. Descubre cómo podemos llevar tu negocio al siguiente nivel.";

    return (
      <React.Fragment>
        {/* Título de la pestaña del navegador */}
        <PageHelmet pageTitle="Nosotros" />

        {/* Cabecera (asumiendo configuración y posible traducción externa) */}
        <Header
          headertransparent="header--transparent"
          colorblack="color--black"
          logoname="logo.png"
        />

        {/* Inicio Área Breadcrumb */}
        {/* Asegúrate que el componente Breadcrumb muestre el título correctamente */}
        <Breadcrumb title={"Nosotros"} />
        {/* Fin Área Breadcrumb */}

        {/* Inicio Área "Nosotros" */}
        <div className="rn-about-area ptb--120 bg_color--1">
          <div className="rn-about-wrapper">
            <div className="container">
              <div className="row row--35 align-items-center">
                <div className="col-lg-5">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src="https://images.pexels.com/photos/3184416/pexels-photo-3184416.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"
                      alt="Imagen Sobre Nosotros" // Alt text traducido
                    />
                  </div>
                </div>
                <div className="col-lg-7">
                  <div className="about-inner inner">
                    <div className="section-title">
                      <h2 className="title">{title}</h2>
                      <p className="description">{description}</p>
                    </div>
                    <div className="row mt--30">
                      {/* Bloque 1: Misión, Visión, etc. (Placeholder) */}
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="about-us-list">
                          <h3 className="title">Nuestra Misión</h3>
                          {/* REEMPLAZAR CON CONTENIDO REAL */}
                          <p>
                            Nacimos de la pasión por la tecnología y el marketing,
                            con la misión de ayudar a empresas como la tuya a
                            destacar en el mundo digital.
                          </p>
                        </div>
                      </div>
                      {/* Bloque 2: Valores, Enfoque, etc. (Placeholder) */}
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="about-us-list">
                          <h3 className="title">Nuestro Enfoque</h3>
                          {/* REEMPLAZAR CON CONTENIDO REAL */}
                          <p>
                            Combinamos creatividad y análisis de datos para
                            ofrecer estrategias personalizadas que generan
                            resultados medibles y duraderos.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Fin Área "Nosotros" */}

        {/* Inicio Área Contador */}
        {/* Asegúrate que CounterOne tenga textos internos traducidos si es necesario */}
        <div className="rn-counterup-area pb--120 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center">
                  {/* Título de la sección de contadores */}
                  <h3 className="fontWeight500">Logros en Números</h3>
                </div>
              </div>
            </div>
            {/* Componente de contadores */}
            <CounterOne />
          </div>
        </div>
        {/* Fin Área Contador */}

        {/* Inicio Área "Finding Us" / Llamada a la acción */}
        <div className="rn-finding-us-area rn-finding-us bg_color--1">
          <div className="inner">
            <div className="content-wrapper">
              <div className="content">
                {/* Título llamada a la acción */}
                <h4 className="theme-gradient">Empieza a Crear Tu Éxito</h4>
                 {/* Texto llamada a la acción (Placeholder - REEMPLAZAR) */}
                <p>
                  Es el momento de transformar tu presencia online. Contáctanos y
                  descubre el plan perfecto para alcanzar tus objetivos. ¡El primer
                  paso hacia el éxito empieza aquí!
                </p>
                 {/* Botón llamada a la acción */}
                <a className="rn-btn btn-white" href="/contact"> {/* Link ajustado a /contact */}
                  Empezar Ahora
                </a>
              </div>
            </div>
            <div className="thumbnail">
              <div className="image">
                 {/* Alt text traducido */}
                <img width={1200} src="https://images.pexels.com/photos/1134188/pexels-photo-1134188.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2" alt="Ilustración sección empezar" />
              </div>
            </div>
          </div>
        </div>
        {/* Fin Área "Finding Us" */}

        {/* Inicio Área Equipo */}
        {/* <div className="rn-team-area bg_color--1 ptb--120">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center mb--25">
             
                  <h2 className="title">Equipo Experto</h2>
                 
                  <p>
                    Contamos con un equipo multidisciplinario de profesionales
                    apasionados y dedicados a la excelencia en cada proyecto.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
           
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="team">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src={teamImg1}
                      alt="Foto Miembro del Equipo" // Alt text traducido
                    />
                  </div>
                  <div className="content">
                  
                    <h4 className="title">Nombre Apellido</h4>
           
                    <p className="designation">Desarrollador/a Web Senior</p>
                  </div>
 
                  <ul className="social-icon">
                    <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
                    <li><a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a></li>
                    <li><a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a></li>
                  </ul>
                </div>
              </div>
           

            
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="team">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src={teamImg2}
                      alt="Foto Miembro del Equipo"
                    />
                  </div>
                  <div className="content">

                    <h4 className="title">Nombre Apellido</h4>
          
                    <p className="designation">Especialista en Marketing</p>
                  </div>
                  <ul className="social-icon">
                     <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
                    <li><a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a></li>
                    <li><a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a></li>
                  </ul>
                </div>
              </div>
       

            
              <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                <div className="team">
                  <div className="thumbnail">
                    <img
                      className="w-100"
                      src={teamImg3}
                      alt="Foto Miembro del Equipo"
                    />
                  </div>
                  <div className="content">
                   
                    <h4 className="title">Nombre Apellido</h4>
              
                    <p className="designation">Consultor/a de Marca</p>
                  </div>
                  <ul className="social-icon">
                     <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a></li>
                    <li><a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a></li>
                    <li><a href="https://twitter.com/" target="_blank" rel="noopener noreferrer"><FaTwitter /></a></li>
                  </ul>
                </div>
              </div>
             
            </div>
          </div>
        </div> */}
        {/* Fin Área Equipo */}

        {/* Inicio Área Testimonios */}
        {/* Asegúrate que Testimonial tenga textos internos traducidos */}
        {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
          <div className="container">
            <Testimonial />
          </div>
        </div> */}
        {/* Fin Área Testimonios */}

        {/* Inicio Área Marcas (Clientes o Partners) */}
        {/* Asegúrate que BrandTwo tenga textos internos traducidos si aplica */}
        <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <BrandTwo />
              </div>
            </div>
          </div>
        </div>
        {/* Fin Área Marcas */}

        {/* Inicio Botón Volver Arriba */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* Fin Botón Volver Arriba */}

        {/* Pie de página (asumiendo traducido externamente) */}
        <Footer />
      </React.Fragment>
    );
  }
}
export default About;